import { useEffect, useState } from 'react'
import {Modal} from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import Orders from '../../components/Orders/Orders';
import { getLoggedUserToken, isLoggedUser } from '../../redux/selectors';
import { connect } from "react-redux";
import DataTableComponent from '../../components/DataTableComponent';
import { useHistory } from 'react-router-dom';
import PaymentService from '../../services/PaymentService';
import { FourthShiftService } from '../../services';
import { setFourthshiftAuthorizationHeader } from '../../utils/FourthShiftAPI';
import { UserInfoService } from '../../services/UserInfo.Service';

const AdminAccount = (props) => {
    const [UserInfo, setUserInfo] = useState(null);
    const [ShowStatusModal, setShowStatusModal] = useState(false);
    const [DataLoading, setDataLoading] = useState(false);
    const [OrderStatusHistoryData, setOrderStatusHistoryData] = useState([]);
    const [ModalTitle, setModalTitle] = useState("");
    const history = useHistory();
    
    useEffect(async () => {
        setFourthshiftAuthorizationHeader(props.userToken);
        const loaded = await UserInfoService.fetch(props.userToken);
        if (loaded)
        {
            setUserInfo( UserInfoService.userInfo);
        }

}, [props.userToken]);

useEffect(() => {
    if (UserInfo != null)
    {
        if (UserInfo.IsAdmin==false)
            history.push("/user/login");
    }

}, [UserInfo]);

const handleAdyenPaymentHistory = (orderGuid) => {
    console.log("Admin.handleAdyenPaymentHistory", orderGuid);

    setDataLoading(true);
    PaymentService.getNotifications(orderGuid).then(res => {
        console.log("Admin.handleAdyenPaymentHistory.getNotifications.Response:", res);

        //console.log(response);
        if (res.status === 200) {
            if (res.data)
            {
                handleDataPointer(res.data, "Adyen Notification History");
                setDataLoading(false);
                return true;
            }
        }
    }).catch(function (error) {
        console.log("Admin.handleAdyenPaymentHistory.getNotifications.Error:");
        console.log(error);
        return error;
    });
}

const handleB2BHistory = (reference) => {
    console.log("Admin.handleB2BHistory", reference);

    setDataLoading(true);
    FourthShiftService.getB2BHistory(reference).then(res => {
        console.log("Admin.handleB2BHistory.getB2BHistory.Response:", res.data);

        //console.log(response);
        if (res.status === 200) {
            if (res.data.data)
            {
                handleDataPointer(res.data.data, "B2B History");
                setDataLoading(false);
                return true;
            }
        }
    }).catch(function (error) {
        console.log("Admin.handleB2BHistory.getB2BHistory.Error:");
        console.log(error);
        return error;
    });
}

const handleDataPointer = (data, title) => {
    console.log("handleDataPointer", data);
    setModalTitle(title);
    setOrderStatusHistoryData(data);
    setShowStatusModal(true);
}

    return (
    <div className="container">
        <hr/>
        <div className="row">
            <div className="col-lg-12">
                <Card>
                    <Card.Body>
                        <Card.Title>Admin - Order History</Card.Title>
                        <Orders isAdmin={UserInfo?.IsAdmin} searchText={"Search Customers"} showB2BHistory={(res)=>handleB2BHistory(res)} showAdyenPaymentHistory={(res)=>handleAdyenPaymentHistory(res)} showOrderStatusHistory={(res)=>handleDataPointer(res, "Order Status History")}></Orders>
                    </Card.Body>
                </Card>
            </div>
        </div>
        <br></br>
        <Modal show={ShowStatusModal} onHide={()=>setShowStatusModal(false)} className="" size="lg">
                <Modal.Header closeButton className="py-2">
                    <Modal.Title><h6>{ModalTitle}</h6></Modal.Title>
                </Modal.Header>
                <Modal.Body className='py-2'>
                    <DataTableComponent dataLoading={DataLoading} data={OrderStatusHistoryData} showQuickAdd={false} showSearch={false}></DataTableComponent>
                </Modal.Body>
            </Modal>
    </div>
    )
}
  
const mapStateToProps = state => {
    const loggedUser = isLoggedUser(state);
    const userToken = getLoggedUserToken(state);
    return { userToken, loggedUser };
}

export default connect(mapStateToProps)(AdminAccount);
